import { useRef, useState, useLayoutEffect } from 'react';

const MARGIN = 8;

/**
 * Viewport clamping for a fixed-position context menu opened at a pointer position.
 * Same rule as DragContextMenu: keep the whole menu inside the window with an 8 px margin.
 *
 * @param {boolean} open      whether the menu is rendered (measurement only makes sense then)
 * @param {{x:number,y:number}} position  requested top-left in viewport coordinates
 * @returns {{ menuRef: React.RefObject, adjustedPosition: {x:number,y:number} }}
 */
export default function useClampedMenuPosition(open, position) {
  const menuRef = useRef(null);
  const [adjustedPosition, setAdjustedPosition] = useState({ x: 0, y: 0 });

  useLayoutEffect(() => {
    if (!open || !menuRef.current || !position) return;
    const menu = menuRef.current;
    let x = position.x;
    let y = position.y;

    if (x + menu.offsetWidth > window.innerWidth - MARGIN) {
      x = window.innerWidth - menu.offsetWidth - MARGIN;
    }
    if (y + menu.offsetHeight > window.innerHeight - MARGIN) {
      y = window.innerHeight - menu.offsetHeight - MARGIN;
    }
    if (x < MARGIN) x = MARGIN;
    if (y < MARGIN) y = MARGIN;

    setAdjustedPosition({ x, y });
  }, [open, position]);

  return { menuRef, adjustedPosition };
}
